module.exports = __webpack_public_path__ + "202408221624/img/cam_1.46f88b5f.png";